import { type Tenant, tenantConfig } from "@albertine/tenant-config";
import { createContext, type ReactNode, useContext, useEffect } from "react";

import { loadTenantCSS } from "../lib/loadTenantCSS";

export const defaultTenant: Tenant = "albertine";

export const tenants = Object.keys(tenantConfig) as Tenant[];

const DesignSystemTenantContext = createContext<Tenant>(defaultTenant);

export function isTenant(value: unknown): value is Tenant {
    return typeof value === "string" && value in tenantConfig;
}

export interface DesignSystemProviderProps {
    tenant?: Tenant;
    children?: ReactNode;
}

export function DesignSystemProvider({
    tenant = defaultTenant,
    children,
}: DesignSystemProviderProps) {
    useEffect(() => {
        void loadTenantCSS(tenant);
    }, [tenant]);

    return (
        <DesignSystemTenantContext.Provider value={tenant}>
            {children}
        </DesignSystemTenantContext.Provider>
    );
}

export function useDesignSystemTenant(): Tenant {
    return useContext(DesignSystemTenantContext);
}
